export default __webpack_public_path__ + "static/media/logo.158b9ee0.png";